query DepartmentsChartData {
  kpiDepartments {
    nodes {
      title
      amount
      linkSearchValue
    }
  }
}
